export const SIZE = 768;
